import * as i0 from "@angular/core";
export class AnalyticsService {
    initializeAnalytics() {
        if (typeof gtag === 'undefined') {
        }
    }
    trackFormSubmission(status) {
        // Google Analytics
        if (typeof gtag !== 'undefined') {
            gtag('event', 'form_submission', {
                'event_category': 'Landing Page',
                'event_label': status,
                'value': status === 'success' ? 1 : 0
            });
        }
    }
}
AnalyticsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AnalyticsService_Factory() { return new AnalyticsService(); }, token: AnalyticsService, providedIn: "root" });
